<template>
	<div class="ranking-module">
		<table class="table-main ranking-module__table">
			<thead>
				<tr>
					<th>번호</th>
					<th>등록일</th>
					<th>타이틀</th>
					<th>하위카테고리수</th>
					<th>시작 일시</th>
					<th>종료 일시</th>
					<th>상태</th>
					<th>관리자명</th>
					<th>삭제</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in rankingList" :key="item.id">
					<td class="ranking-module__num">{{ item.id }}</td>
					<td class="ranking-module__num">{{ item.createdAt }}</td>
					<td class="ranking-module__title">
						<router-link
							:to="`/product/modify-ranking-module/${item.id}`"
							class="link"
							>{{ item.title }}</router-link
						>
					</td>
					<td class="ranking-module__num">
						{{ item.categoryCount }}
					</td>
					<td class="ranking-module__date">{{ item.startOn }}</td>
					<td class="ranking-module__date">{{ item.endOn }}</td>
					<td class="ranking-module__status">{{ item.status }}</td>
					<td class="ranking-module__name">{{ item.nickName }}</td>
					<td class="ranking-module__button">
						<button class="btn blue" @click="deleteList(item.id)">
							삭제
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<PaginationBox
			slot="pagination"
			:total-item="totalItem"
			:limit="limit"
			:offset="offset"
			@to="search($event.offset)"
		/>
	</div>
</template>
<script>
	import PaginationBox from '@/components/PaginationBox';
	import moment from 'moment';

	export default {
		data() {
			return {
				offset: 0,
				limit: 10,
				totalItem: 0,
				rankingList: [],
			};
		},
		created() {
			this.getList();
		},
		components: {
			PaginationBox,
		},
		methods: {
			search(offset = 0) {
				this.offset = offset;
				this.getList();
			},
			async getList() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/v3/api/category/rankingCuration?offset=${this.offset}&limit=${this.limit}`
					);
					this.rankingList = data.data;
					this.rankingList.forEach(item => {
						item.startOn = moment
							.unix(item.startOn)
							.format('YYYY-MM-DD HH:mm:ss');
						item.endOn = moment
							.unix(item.endOn)
							.format('YYYY-MM-DD HH:mm:ss');
						item.createdAt = moment
							.unix(item.createdAt)
							.format('YYYY-MM-DD HH:mm:ss');
						switch (item.status) {
							case 'ready':
								item.status = '대기';
								break;
							case 'open':
								item.status = '노출';
								break;
							case 'closed':
								item.status = '미노출';
								break;
							default:
								break;
						}
					});
					this.totalItem = data.contentTotal;
				} catch (err) {
					console.error(err);
				}
			},
			async deleteList(id) {
				if (!confirm('정말 삭제하시겠습니까?')) return;
				try {
					await this.$axiosAdmin2.delete(
						`/v3/api/category/rankingCuration/${id}`
					);
					alert('삭제 되었습니다.');
					this.getList();
				} catch (err) {
					console.error(err);
					alert(
						'삭제 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의바랍니다.'
					);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.ranking-module {
		&__table {
			margin: 30px 0;
		}
	}
</style>
